"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TFranOrgBody = exports.TUserType = exports.TStoreId = exports.TStoreEmailCategorizations = exports.TStoreEmails = exports.UserType = void 0;
const t = __importStar(require("io-ts"));
const mapping_1 = require("../utils/mapping");
var UserType;
(function (UserType) {
    UserType["DirOfOperations"] = "DirOfOperations";
    UserType["GeneralUserFranchisee"] = "GeneralUserFranchisee";
    UserType["MultiUnitManager"] = "MultiUnitManager";
    UserType["ReportingAdministrator"] = "ReportingAdministrator";
    UserType["ReportingOperator"] = "ReportingOperator";
    UserType["RestaurantManager"] = "RestaurantManager";
    UserType["VPOperations"] = "VPOperations";
})(UserType || (exports.UserType = UserType = {}));
exports.TStoreEmails = t.string;
exports.TStoreEmailCategorizations = t.partial({
    [UserType.DirOfOperations]: t.array(exports.TStoreEmails),
    [UserType.GeneralUserFranchisee]: t.array(exports.TStoreEmails),
    [UserType.MultiUnitManager]: t.array(exports.TStoreEmails),
    [UserType.ReportingAdministrator]: t.array(exports.TStoreEmails),
    [UserType.ReportingOperator]: t.array(exports.TStoreEmails),
    [UserType.RestaurantManager]: t.array(exports.TStoreEmails),
    [UserType.VPOperations]: t.array(exports.TStoreEmails),
});
exports.TStoreId = t.string;
exports.TUserType = new mapping_1.Enum(UserType);
exports.TFranOrgBody = t.record(t.string, exports.TStoreEmailCategorizations);
//# sourceMappingURL=franorg.js.map